import React from 'react'
import LeagueSelectionPage from './modules/LeagueSelectionPage'

const LeagueSelection = () => {
 
  return (
    <div className="flex min-h-full flex-col gap-3 bg-customLightMilkWhite dark:bg-gradient-to-br dark:from-custom_dark_background dark:via-customSurface dark:to-custom_dark_primary2 p-2 lg:p-4">
      {/* <div className="rounded-2xl border dark:border-customMuted/30 border-customAccent/20 bg-white/90 p-4 shadow-xl shadow-customAccent/10 backdrop-blur-sm dark:bg-customSurface/90 dark:shadow-customSurface">
        <header className="flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h1 className="text-2xl font-semibold text-customInk dark:text-customHeading">League selection</h1>
            <p className="text-sm text-customSecondaryText dark:text-customMuted">
              Curate leagues and events with quick filters and smart selection tools.
            </p>
          </div>
          <div className="flex items-center gap-2 rounded-xl border border-customAccent/30 bg-customAccent/5 px-3 py-2 text-xs font-medium text-customAccent dark:border-customAccent/40 dark:bg-customAccent/10 dark:text-customHeading">
            <span className="inline-flex h-2 w-2 rounded-full bg-customAccent" />
            Updated moments ago
          </div>
        </header>
      </div> */}
      <LeagueSelectionPage />
    </div>
  )
}

export default LeagueSelection
